<select
  class="form-select"
  [(ngModel)]="selectedPage"
  name="category"
  (ngModelChange)="onChange($event)"
>
  <option
    *ngFor="let tech of pages"
    [attr.selected]="selectedPage.name == tech.name"
    [ngValue]="tech"
  >
    {{ tech.name }}
  </option>
</select>
